import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from 'src/app/pages/login/services/auth.service';
import { isAdminOrSaasModule, normalizeModuleId } from './module-access-policy';

export function rolesGuard(requiredRoles: string[]): CanMatchFn {
  return (route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (!requiredRoles || requiredRoles.length === 0) {
      return router.createUrlTree(['/home']);
    }

    return auth.getRolesFromTokenOnlyId().pipe(
      map(userRoles => {
        if (userRoles) {
          const restrictedRole = requiredRoles.find(isAdminOrSaasModule);

          if (restrictedRole) {
            const hasAssignedModule =
              hasAdminRole(userRoles) ||
              userRoles.includes(normalizeModuleId(restrictedRole));

            return auth.canAccessModuleByPolicy(
              restrictedRole,
              hasAssignedModule
            )
              ? true
              : router.createUrlTree(['/home']);
          }

          if (hasAdminRole(userRoles)) return true;
          const hasRole = checkRolesMatch(requiredRoles, userRoles);
          return hasRole ? true : router.createUrlTree(['/home']);
        }
        return router.createUrlTree(['/home']);
      })
    );
  };
}

const hasAdminRole: (userRoles: string[]) => boolean = userRoles => {
  return userRoles.includes('admin');
};

const checkRolesMatch: (
  requiredRoles: string[],
  userRoles: string[]
) => boolean = (requiredRoles, userRoles) => {
  return requiredRoles.some(role => userRoles.includes(role));
};
